import { Component, inject, OnDestroy } from '@angular/core'
import { ModalHeaderComponent } from '../modal-header/modal-header.component'
import { ModalBodyComponent } from '../modal-body/modal-body.component'
import { ModalFooterComponent } from '../modal-footer/modal-footer.component'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { Subscription } from 'rxjs'
import { ActiveFilterListComponent } from '../../table/filters/active-filter-list/active-filter-list.component'
import { LabeledPropertyComponent } from '../../labeled-property/labeled-property.component'
import { Filter, FilterService } from 'src/app/shared/services/filter/filter.service'
import { HeaderModal } from '../../table/headers/table-header.component'
import { NumberRange, NumberRangeSelector } from '../../number-range-selector/number-range-selector.component'
import { NumberRangeFilter } from 'src/app/shared/services/filter/number-range-filter'

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    ActiveFilterListComponent,
    NumberRangeSelector,
  ],
  selector: 'app-number-range-filter-modal',
  styles: '',
  template: `
    @if(filter) {
        <div app-modal-header>{{ filter.state.config.meta.fieldDisplay }}</div>
        <div app-modal-body>
            <p>Select a filter value for the column {{ filter.state.config.meta.fieldDisplay }} below</p>
            <div app-labeled-property [label]="filter.state.config.meta.fieldDisplay">
              <div app-number-range-selector [value]="filter.state" (valueChange)="handleChange($event)" [allowRange]="filter.state.config.allowRange"></div>
            </div>
            <app-active-filter-list
            [filterGroup]="filter.state.config.meta.fieldGroup"
            [filterName]="filter.state.config.meta.fieldName"
            ></app-active-filter-list>
        </div>
        <div app-modal-footer>
            <button class="action-btn" (click)="onClose()">Close</button>
        </div>
    }
    `,
})
export class NumberRangeFilterModalComponent implements HeaderModal, OnDestroy {
  private modal = inject(NgbActiveModal)
  private filterService = inject(FilterService)

  private subscription = new Subscription()
  public filter: NumberRangeFilter | undefined

  public init(
    fieldGroup: string,
    fieldName: string,
  ): void {
    this.subscription.add(
      this.filterService.state(fieldGroup).subscribe((group) => {
        const filter = group[fieldName] as Filter | undefined
        if(filter?.type === 'NUMBER_RANGE') {
          this.filter = filter
        }
      }),
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }


  handleChange(evt: NumberRange) {
    if(this.filter) {
      this.filterService.dispatch(
        NumberRangeFilter.SetNumberRangeFilterValueAction(evt, this.filter.state.config.meta),
      )
    }
  }

  public onClose() {
    this.modal.close()
  }
}
